<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/login" class="btn">
                Looking to login?
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <h2>PPE Locator</h2>
                  <h4>Register for free and help save lives.</h4>
                  <hr>
                </div>
              </div>
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-danger">
                      <i class="ti ti-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Free Account</h5>
                    Request PPEs if you need them. Offer PPEs if you have them.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-warning">
                      <i class="ti-bar-chart-alt"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Save Lives</h5>
                    Help us save lives of those who are in the frontlines helping people.
                  </div>
                </div>
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-info">
                      <i class="ti-headphone"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Thank you!</h5>
                    Thank you for helping us save the world!
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <form method="#" action="#">
                  <div class="card card-plain">
                    <div class="content">
                    <div class="form-group">
                      <input
                        type="email"
                        name="business_email"
                        v-model="model.email"
                        placeholder="Email"
                        class="form-control">
                    </div>
                    <div class="form-group">
                      <input
                        type="text"
                        name="name"
                        v-model="model.name"
                        placeholder="Name"
                        class="form-control">
                    </div>
                    <div class="form-group">
                      <input
                        type="tel"
                        name="phone"
                        v-model="model.phone"
                        placeholder="Phone Number"
                        class="form-control">
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        name="password"
                        v-model="model.password"
                        placeholder="Password"
                        class="form-control">
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        name="password_confirm"
                        placeholder="Password Confirmation"
                        class="form-control">
                    </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" v-if="!loading" @click.prevent="createCognitoUser()" class="btn btn-fill btn-danger btn-wd">Sign Up!</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              Copyright &copy; 2020 Interdisciplinary Humanistic Technologies All rights reserved.
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
        <li>
          <router-link to="/admin">
            Dashboard
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        loading: false,
        model: {
          email: '',
          phone: '',
          password: '',
          password_confirm: '',
          address: {
            street_address: '',
            locality: '',
            region: '',
            postal_code: '',
            country: 'United States'
          }
        },
        cognito_user_id: ''
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      createCognitoUser () {
        if (this.cognito_user_id !== '') {
          console.log('incorrectly trying to create cognito user after it has been done. ignoring call.')
          return
        }

      // this.model.other_url = this.model.other_url.replace('https://', '').replace('http://', '')

        console.log('i am in the createcognitouser')
        let attributeList = []
        // attributeList.push({ Name: 'email', Value: this.model.business_email })
        attributeList.push({ Name: 'phone_number', Value: '+18181234567' })
        attributeList.push({ Name: 'website', Value: 'the website url here...' })
        attributeList.push({ Name: 'address', Value: 'and adress would go here' })
        attributeList.push({ Name: 'name', Value: 'this is the name' })

        this.$cognitoAuth.signupWithAttributeList(this.model.email.toLowerCase(), this.model.password, attributeList, (err, result) => {
          if (err) {
            this.error = err
            console.error(err)
            swal({
              title: 'Error',
              text: err,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          } else {
            console.log('Signup successful:', result)
            this.cognito_user_id = result.userSub
            this.loading = false
            this.$router.replace({path: '/', query: {username: this.model.business_email}})
          }
        })
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register.vue